import { Map } from "immutable";
import TitleTypes from "views/stores/TitleTypes";
const SetWidgetTitle = (titlesMap, widget, title) => {
  if (!title) {
    return titlesMap;
  }
  const widgetTitles = titlesMap.get(TitleTypes.Widget, Map());
  const newWidgetTitles = widgetTitles.set(widget.id, title);
  return titlesMap.set(TitleTypes.Widget, newWidgetTitles);
};
export default SetWidgetTitle;
